import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { FaFileVideo } from "react-icons/fa";

import fy26_27b from '../../assests/sgPdf/9. Notice/FY 2026-27/SGFL AFM Notice Intimation.pdf';
import FY26_27a from '../../assests/sgPdf/Annual Report/FY 2026-27/SG Finserve AR 2026 Intimation.pdf';
import fy26_27c from '../../assests/sgPdf/Annual Report/FY 2026-27/scrutinizerreport.pdf';
import fy26_27d from '../../assests/sgPdf/Annual Report/FY 2026-27/BRSR _FY26.pdf';
import fy26_27e from '../../assests/sgPdf/Annual Report/FY 2026-27/Proceeding of 32nd AGM.pdf';
import fy26_27f from '../../assests/sgPdf/Annual Report/FY 2026-27/Postal Ballot Notice.pdf';
import FY24_25 from '../../assests/sgPdf/Annual Report/j. FY 2024-25/30th annual report of the company.pdf';
import FY24_25a from '../../assests/sgPdf/Annual Report/j. FY 2024-25/Proceedings of the 30th Annual General Meeting-SGFL.pdf';
import FY24_25b from '../../assests/sgPdf/Annual Report/j. FY 2024-25/Voting Result of 30th Annual General Meeting.pdf';
import FY24_25c from '../../assests/sgPdf/Annual Report/j. FY 2024-25/Postal Ballot Results 05.10.2024.pdf';
import FY24_25d from '../../assests/sgPdf/Annual Report/j. FY 2024-25/Scrutnizer Report_31.12.2024.pdf';
import FY23_24 from '../../assests/sgPdf/Annual Report/i. FY 2023-24/29th Annual Report.pdf';
import FY22_23 from '../../assests/sgPdf/Annual Report/ii. FY 2022-23/28th Annual Report of MSL.pdf';
import FY21_22 from '../../assests/sgPdf/Annual Report/iii. FY 2021-22/31.03.2022.pdf';
import FY21_22a from '../../assests/sgPdf/Annual Report/iii. FY 2021-22/27th Annual Report of MSL.pdf';
import FY20_21 from '../../assests/sgPdf/Annual Report/iv. FY 2020-21/31.03.2021.pdf';
import FY19_20 from '../../assests/sgPdf/Annual Report/v. FY 2019-20/31.03.2020.pdf';
import FY18_19 from '../../assests/sgPdf/Annual Report/vi. FY 2018-19/31.03.2019.pdf';
import FY17_18 from '../../assests/sgPdf/Annual Report/vii. FY 2017-18/31.03.2018.pdf';
import FY16_17 from '../../assests/sgPdf/Annual Report/viii. FY 2016-17/31.03.2017.pdf';

import FY25_26b from '../../assests/sgPdf/Annual Report/FY 2025-26/BRSR_FY25.pdf';
import FY25_26c from '../../assests/sgPdf/Annual Report/FY 2025-26/SG Finserve AR 24-25 15.09.25 (1).pdf';
import FY25_26d from '../../assests/sgPdf/Annual Report/FY 2025-26/Proceedings of 31st AGM.pdf';
import FY25_26e from '../../assests/sgPdf/Annual Report/FY 2025-26/Scrutinizer report_voting result_23-09-2025.pdf';
import FY25_26f from '../../assests/sgPdf/Annual Report/FY 2025-26/Scrutinizer Report and Voting results_Postal Ballot_17.01.2026.pdf';
import FY25_26g from '../../assests/sgPdf/Annual Report/FY 2025-26/SG_Finserve_Postal Ballot_09022026.pdf';
import FY25_26h from '../../assests/sgPdf/Annual Report/FY 2025-26/Outcome of Postal Ballot Signed.pdf';
import FY25_26i from '../../assests/sgPdf/Annual Report/FY 2025-26/31st Notice of AGM.pdf';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const AnnualReport = () => {
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
const [show1, setShow1] = useState(false);
const [show2, setShow2] = useState(false);
const handleClose1 = () => setShow1(false);
const handleShow1 = () => setShow1(true);
const handleClose2 = () => setShow2(false);
const handleShow2 = () => setShow2(true);

    const [selectedOption, setSelectedOption] = useState("option0"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>


            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>AGM/ EGM/ Postal Ballot</h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>AGM/ EGM/ Postal Ballot</h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option0">FY 2026-27</option>
                                <option value="option">FY 2025-26</option>
                                <option value="option9">FY 2024-25</option>
                                <option value="option8">FY 2023-24</option>
                                <option value="option1">FY 2022-23</option>
                                <option value="option2">FY 2021-22</option>
                                <option value="option3">FY 2020-21</option>
                                <option value="option4">FY 2019-20</option>
                                <option value="option5">FY 2018-19</option>
                                <option value="option6">FY 2017-18</option>
                                <option value="option7">FY 2016-17</option>
                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option0" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY26_27a} target='blank'><h6>32nd Annual Report</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27b} target='blank'><h6>32nd Notice of AGM</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27c} target='blank'><h6>Scrutinizer Report and Voting Results of 32nd AGM</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27d} target='blank'><h6>BRSR _FY26</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27e} target='blank'><h6>Proceeding of 32nd AGM</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileVideo size={25} style={{ color: 'red' }} />
                                    <a  onClick={handleShow2}><h6>Video Recording of 32nd AGM 

                                </h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27f} target='blank'><h6>Postal Ballot Notice 03-11-2026</h6></a>
                                </div>
                                
                                
                                
                            </>

                        )}
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26c} target='blank'><h6>31st Annual Report of the Company</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26b} target='blank'><h6>BRSR_FY25</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26d} target='blank'><h6>Proceedings of 31st AGM</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26e} target='blank'><h6>Scrutinizer report_voting result_23-09-2025</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26f} target='blank'><h6>Scrutinizer Report and Voting results_Postal Ballot_17.01.2026</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26g} target='blank'><h6>Notice of postal ballot dated February 10, 2026</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26h} target='blank'><h6>Outcome of Postal Ballot Signed</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY25_26i} target='blank'><h6>31st Notice of AGM</h6></a>
                                </div>
                                
                                <div className="pdf-clas">
                                    <FaFileVideo size={25} style={{ color: 'red' }} />
                                    <a  onClick={handleShow1}><h6>Video recording of 31st AGM

                                </h6></a>
                                </div>
                                
                                
                            </>

                        )}
                        {selectedOption === "option9" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY24_25} target='blank'><h6>30th Annual Report of the Company</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY24_25a} target='blank'><h6>Proceedings of the 30th Annual General Meeting-SGFL</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY24_25b} target='blank'><h6>Voting Result of 30th Annual General Meeting</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY24_25c} target='blank'><h6>Postal Ballot Results for the FY 2024-25</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY24_25d} target='blank'><h6>Scrutnizer Report_31.12.2024</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileVideo size={25} style={{ color: 'red' }} />
                                    <a  onClick={handleShow}><h6>Video recording of AGM

</h6></a>
                                </div>

                            </>

                        )}
                        
                        

      
                        
                        {selectedOption === "option8" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY23_24} target='blank'><h6>29th Annual Report of SGFL.pdf</h6></a>
                                </div>

                            </>

                        )}
                        {selectedOption === "option1" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY22_23} target='blank'><h6>28th Annual Report of MSL.pdf</h6></a>
                                </div>

                            </>

                        )}
                        {selectedOption === "option2" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY21_22} target='blank'><h6>31.03.2022.pdf</h6></a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY21_22a} target='blank'><h6>27th Annual Report of MSL</h6></a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option3" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY20_21} target='blank'><h6>31.03.2021.pdf</h6></a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option4" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY19_20} target='blank'><h6>31.03.2020.pdf</h6></a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option5" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY18_19} target='blank'><h6>31.03.2019.pdf</h6></a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option6" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY17_18} target='blank'><h6>31.03.2018.pdf</h6></a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option7" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={FY16_17} target='blank'><h6>31.03.2017.pdf</h6></a>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </section>

    <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body><iframe width="100%" height="400" src="https://sgpdf.s3.ap-south-1.amazonaws.com/sg-pdf/CDSL-SG_FINSERVE_LIMITED_24Sep_24.mp4"></iframe></Modal.Body>
        
    </Modal>
    <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body><iframe width="100%" height="400" src="https://sgpdf.s3.ap-south-1.amazonaws.com/sg-pdf/23-09-25+CDSL+-sg+finserve.mp4"></iframe></Modal.Body>
        
    </Modal>
    <Modal size="lg" show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body><iframe width="100%" height="400" src="https://sgfinserve.com/sg_files/Annual%20General%20Meeting%20of%20SG%20Finserve%20Limited-20260630%200609-1.mp4"></iframe></Modal.Body>
        
    </Modal>

            <Footer />


        </>
    )
}

export default AnnualReport